/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ReleaseFlagRequest extends models.FeatureFlagRequestBase {
    constructor() {
        super();
        this.setDiscriminator("ReleaseFlagRequest");
    }

    getFixupPrototypeFunction() { return ReleaseFlagRequest.fixupPrototype; }

    static newInstance(model: Partial<ReleaseFlagRequest>): ReleaseFlagRequest {
        let obj = Object.assign(new ReleaseFlagRequest(), model);
        ReleaseFlagRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ReleaseFlagRequest>): ReleaseFlagRequest {
        if (!model) return null;
        return ReleaseFlagRequest.newInstance(<ReleaseFlagRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ReleaseFlagRequest) {
        if (!obj) return;

        models.ReleaseFlagRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ReleaseFlagRequest): boolean {
        if (models.FeatureFlagRequestBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ReleaseFlagRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
